import type {
  CreateRoleRequest,
  RoleDetailResponse,
  RoleSummaryResponse,
  UpdateRoleRequest,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export const authorizationApi = {
  listRoles() {
    return apiRequest<readonly RoleSummaryResponse[]>('/authorization/roles');
  },

  getRole(id: string) {
    return apiRequest<RoleDetailResponse>(`/authorization/roles/${id}`);
  },

  createRole(body: CreateRoleRequest) {
    return apiRequest<RoleDetailResponse>('/authorization/roles', { method: 'POST', body });
  },

  updateRole(id: string, body: UpdateRoleRequest) {
    return apiRequest<RoleDetailResponse>(`/authorization/roles/${id}`, {
      method: 'PATCH',
      body,
    });
  },

  archiveRole(id: string) {
    return apiRequest<{ archived: true }>(`/authorization/roles/${id}/archive`, {
      method: 'POST',
    });
  },
};
